import {useEffect, useRef, useState} from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Mousewheel} from 'swiper/modules';
import SubSection from './components/SubSection';
import MainSection from './components/MainSection';

import 'swiper/css';
import 'swiper/css/navigation';

export default function MainPage() {

  const isSwiping = useRef(false);
  const swiperRef = useRef(null);

  const [sectionList, setSectionList] = useState([]);

  const handleWheel = (e) => {
    if (window.scrollY === 0) {
      swiperRef.current.mousewheel.enable();
    }
    else {
      swiperRef.current.mousewheel.disable();
    }

    if (window.scrollY === 0  && (swiperRef.current.activeIndex < 2 || isSwiping.current)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
     fetch(`${process.env.REACT_APP_STATIC_URL}/data/Main_Sub_Section.json`, {
       method: 'GET',
       mode: 'cors',
       headers: {
         'Content-Type': 'application/json'
       }
     }).then(res => res.json().then(data => setSectionList(data)));

    window.addEventListener('wheel', handleWheel, { passive: false });

    return () => window.removeEventListener('wheel', handleWheel);
  }, []);


  return (
    <div>
      <Header/>
      <main>
        <Swiper
          className="h-screen"
          direction={'vertical'} // 세로
          slidesPerView={1} // 한 장 씩
          spaceBetween={0} // 간격
          speed={800} // 속도
          navigation={false}
          watchOverflow={true}
          touchReleaseOnEdges={true}
          mousewheel={{
            releaseOnEdges: true,
            forceToAxis: true,
            sensitivity: 0.3,
            thresholdDelta: 30,
            thresholdTime: 500
          }}
          modules={[Mousewheel]}
          onSlideChange={() => {
            isSwiping.current = true;

            swiperRef.current.mousewheel.disable();

            setTimeout(() => isSwiping.current = false, 800);
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          <SwiperSlide>
            <MainSection />
          </SwiperSlide>

          {
            sectionList.map((item, idx) =>
              <SwiperSlide>
                <SubSection key={idx} data={item}/>
              </SwiperSlide>
            )
          }
        </Swiper>
        <Footer/>
      </main>
    </div>
  );
}